import apiClient from './client';

export interface LoginData {
  email: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  message: string;
  user: {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    roles: string[];
    organization: string;
    token: string;
    refreshToken: string;
  };
}

export interface ForgotPasswordData {
  email: string;
  portal?: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

export interface ResetPasswordData {
  token: string;
  newPassword: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  message: string;
}

class AuthService {
  async login(data: LoginData): Promise<LoginResponse> {
    const response = await apiClient.post('/auth/login', data);
    return response.data;
  }

  async getCurrentUser() {
    const response = await apiClient.get('/auth/me');
    return response.data;
  }

  async forgotPassword(data: ForgotPasswordData): Promise<ForgotPasswordResponse> {
    const response = await apiClient.post('/auth/forgot-password', {
      ...data,
      portal: 'admin'
    });
    return response.data;
  }

  async resetPassword(data: ResetPasswordData): Promise<ResetPasswordResponse> {
    const response = await apiClient.post('/auth/reset-password', data);
    return response.data;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}

export const authService = new AuthService();
